import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'HomePage',
          component: resolve => require(['@/pages/homePage'], resolve)
        },
        {
          path: 'index/:id',
          name: 'HomePage2',
          component: resolve => require(['@/pages/homePage'], resolve)
        },
        {
          path: 'profile',
          name: 'Profile',
          component: resolve => require(['@/pages/profile'], resolve)
        },
        {
          path: 'searchresult',
          name: 'searchResult',
          component: resolve => require(['@/pages/searchresult'], resolve)
        }

        // {
        //   path: 'player',
        //   name: "PlayerPage",
        //   component: PlayerPage
        // }
      ]
    },
    {
      path: '/download',
      name: 'DownLoad',
      component: resolve => require(['@/pages/downPage'], resolve)
    },
    {
      path: '/copyright/:type',
      name: 'Copyright',
      component: resolve => require(['@/pages/copyright'], resolve)
    },
    {
      path: '/license.html',
      name: 'License',
      component: resolve => require(['@/pages/license'], resolve)
    },
    {
      path: '/gonggao.html',
      name: 'Parentchild',
      component: resolve => require(['@/pages/parentchild'], resolve)
    },
    {
      path: '/privacy_policy.html',
      name: 'PrivacyPolicy',
      component: resolve => require(['@/pages/privacy_policy'], resolve)
    },
    {
      path: '/phone.html',
      name: 'Phone',
      component: resolve => require(['@/pages/phone'], resolve)
    },
    // {
    //   path: '/publish.html',
    //   name: 'Publish',
    //   component: Publish
    // },
    {
      path: '/sdk.html',
      name: 'Sdk',
      component: resolve => require(['@/pages/sdk'], resolve)
    },
    {
      path: '/storage.html',
      name: 'Storage',
      component: resolve => require(['@/pages/storage'], resolve)
    },
    {
      path: '/vod_agreement.html',
      name: 'Vod_agreement',
      component: resolve => require(['@/pages/vod_agreement'], resolve)
    },
    {
      path: '/tips/360.html',
      name: 'Tips',
      component: resolve => require(['@/pages/advertisement/tips360'], resolve)
    },
    {
      path: '/minisite/360.html',
      name: 'Minisite',
      component: resolve =>
        require(['@/pages/advertisement/minisite360'], resolve)
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js